import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Item, MoreMenuContainer, Container } from "./style";
import { withRouter } from "react-router-dom";
import { Spinner } from "../../../../components/loading";
import { BoxLoading } from "../../../../components/loading";
import {
  FAILURE,
  SENDING,
  SUCCESS,
  BEFORE_SENDING,
  PRE_SEND
} from "../../../../constants/statusOfUploadImages";

const imageUploadMessage = index => ({
  [BEFORE_SENDING]: `در انتظار ارسال عکس ${index}`,
  [SENDING]: `در حال ارسال عکس ${index}`,
  [PRE_SEND]: `عکس ${index} قبلا با موفقیت ارسال شده‌است.`,
  [SUCCESS]: `عکس ${index} با موفقیت ارسال شد.`,
  [FAILURE]: `ارسال عکس ${index} با  خطا روبه‌رو شد.`
});
const Index = ({ imagesRequestStatus, modalStatus, mainRequestLoading }) => {
  useEffect(() => {
    if (modalStatus) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modalStatus]);
  const overallStateOfModal = () => {
    const sendingImages = imagesRequestStatus.filter(item => item === SENDING);
    const beforeSendingImages = imagesRequestStatus.filter(
      item => item === BEFORE_SENDING
    );
    if (sendingImages.length > 0) {
      return "در حال ارسال عکس";
    } else if (beforeSendingImages.length === imagesRequestStatus.length) {
      return "در حال ارسال اطلاعات";
    } else {
      return "اطلاعات با موفقیت ثبت شد.";
    }
  };
  return (
    <Container show={modalStatus}>
      <div className="overlay" />
      <MoreMenuContainer
        show={modalStatus}
        count={imagesRequestStatus.length + 1}
      >
        <div className="top-section">
          <div className="top-loading-container">
            <BoxLoading />
          </div>
          <div className="title">{overallStateOfModal()}</div>
          <div className="note">چند لحظه صبر کنید...</div>
        </div>
        <div className="bottom-section">
          <Item
            show={modalStatus}
            type="primary"
            isLoading={mainRequestLoading}
          >
            {mainRequestLoading ? (
              <Spinner type="primary_blue" />
            ) : (
              <i className="item-icon icon mapsa-tick" />
            )}
            <div className="item-text">
              {mainRequestLoading
                ? "در حال ارسال اطلاعات"
                : "اطلاعات با موفقیت ارسال شد."}
            </div>
          </Item>

          {imagesRequestStatus.map((item, key) => {
            return (
              <Item
                show={modalStatus}
                key={key}
                type={item === FAILURE ? "error" : "primary"}
                isLoading={item === SENDING}
              >
                {item === SENDING && <Spinner type="primary_blue" />}
                {(item === SUCCESS || item === PRE_SEND) && (
                  <i className="item-icon icon mapsa-tick" />
                )}
                {item === FAILURE && (
                  <i className="item-icon icon mapsa-close" />
                )}
                {item === BEFORE_SENDING && <i className="item-icon" />}
                <div className="item-text">
                  {imageUploadMessage(key + 1)[item]}
                </div>
              </Item>
            );
          })}
        </div>
      </MoreMenuContainer>
    </Container>
  );
};

const mapStateToProps = store => {
  return {
    imagesRequestStatus: store.UploadImage.imagesRequestStatus,
    mainRequestLoading: store.UploadImage.mainRequestLoading,
    modalStatus: store.UploadImage.modalStatus
  };
};

export default connect(mapStateToProps)(withRouter(Index));
